module.exports = __webpack_public_path__ + "img/Sam.82216990.png";